// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Qp6O","footer":"ModalUpdate_footer__3c9B9"};